import { HiLightBulb, HiOutlineLightBulb } from 'react-icons/hi';

export const fields = {
  language: ['EN', 'UA'],
  theme: [<HiLightBulb size="20" />, <HiOutlineLightBulb size="20" />],
};
